// extracted by mini-css-extract-plugin
export default {"codeInput":"index_codeInput__-QoG1","but":"index_but__8XBAm"};